export const FIELD_TYPE_BOOL = 'bool';
export const FIELD_TYPE_CHOICE = 'choice';
export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_EMAIL = 'email';
export const FIELD_TYPE_FILE = 'file';
export const FIELD_TYPE_MANY = 'many';
export const FIELD_TYPE_NUMBER = 'number';
export const FIELD_TYPE_PHONE = 'phone';
export const FIELD_TYPE_PHOTO = 'photo';
export const FIELD_TYPE_STRING = 'string';



// WEBPACK FOOTER //
// ./js/const/fieldType.js